<template>
  <div class="spare-part-agreement-print">
    <div style="width: 210mm; margin: 0mm auto">
      <el-button class="printBtn" type="primary" @click="printHandle">打印</el-button>
    </div>
    <table id="print" class="print-table">
      <thead>
        <tr>
          <td>
            <!-- 这里给页眉占位 -->
            <header class="print-header">
              <img class="company-logo" :src="$tenant.stepIcon">
              <div class="company-standad">GK202412</div>
            </header>
          </td>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>
            <div class="print-area">
              <div class="printItem">
                <div class="title">备品协议</div>
                <section class="contract-info">
                  <div class="flex-justify">
                    <div class="flex-left">
                      合同编号：
                      <span class="display-value">{{agreement.clientContractNo}}</span>
                      <input v-model="agreement.clientContractNo" placeholder="请输入合同编号" class="editable-input">
                    </div>
                  </div>
                  <div class="font-bold">
                    甲方：
                    <span class="display-value">{{agreement.customerName}}</span>
                    <input v-model="agreement.customerName" placeholder="请输入甲方名称" class="editable-input" style="width: 250px;">（以下简称：甲方）
                  </div>
                  <div class="font-bold">
                    乙方：
                    <span class="display-value">{{agreement.belongToCustomerNo}}</span>
                    <input v-model="agreement.belongToCustomerNo" placeholder="请输入乙方信息" class="editable-input" style="width: 250px;">（以下简称：乙方）
                  </div>
                  <div class="agreement-body">
                    <p>乙方同意为甲方市场提供适当数量的服务备品﹙以下简称备品﹚用于乙方产品的售后服务，备用期间双方达成如下协议：</p>
            
                    <div class="section-content">
                      <span class="section-number">
                        1、</span>备用期限：从<span class="display-value">{{agreement.startDate}}</span>
                      <input v-model="agreement.startDate" placeholder="开始日期" class="date-input editable-input">
                      至<span class="display-value">{{agreement.expirationDate}}</span>
                      <input v-model="agreement.expirationDate" placeholder="结束日期" class="date-input editable-input">止。
                    </div>
            
                    <div class="section-content">
                      <span class="section-number">2、</span>备品使用：
                    </div>
                    <div class="section-content">
                      1）按乙方产品使用说明书并严格按说明书操作要求使用乙方备品。
                    </div>
                    <div class="section-content">
                      2）保修期内，免费维修和更换；超过保修期限外服务的，按乙方报价结算产品和维修费用。
                    </div>
            
                    <div class="section-content">
                      <span class="section-number">3、</span>甲方在使用中如有疑问应及时与乙方业务人员联系，乙方应及时予以指导和意见。
                    </div>
            
                    <div class="section-content">
                      <span class="section-number">4、</span>若备品使用效果达不到甲方要求，则甲方立即将备品完整寄还至乙方﹙包括外包装及随机配件﹚。
                    </div>
            
                    <div class="section-content">
                      <span class="section-number">5、</span>若非乙方原因导致备品损坏，则按《备用机型清单》价格购买和付款。
                    </div>
            
                    <div class="section-content">
                      <span class="section-number">6、</span>账务核对：备用期间甲乙方服务部每三个月相互核对一次备品账务。
                    </div>
            
                    <div class="section-content">
                      <span class="section-number">7、</span>甲方应在备用期期满后7天内将完好备品返还给乙方，逾期不还的视为甲方同意购买，甲方应于备用期满后的第8天按照《备用机型清单》向乙方支付备品货款，逾期支付备品货款的，甲方还应当按照日万分之五的标准支付违约金。
                    </div>
            
                    <div class="section-content">
                      <span class="section-number">8、</span>未尽事宜，由双方友好协商解决，协商不成的，双方同意提交乙方所在地人民法院管辖。
                    </div>
            
                    <div class="section-content">
                      <span class="section-number">9、</span>甲乙双方确认授权以下人员负责对账、收货确认、备品回寄等工作：
                    </div>
            
                    <div class="section-content indent">
                      甲方人员：姓名【<span class="display-value">{{agreement.customerContact}}</span><input v-model="agreement.customerContact" placeholder="甲方联系人" class="editable-input">】，联系电话：【<span class="display-value">{{agreement.customerPhone}}</span><input v-model="agreement.customerPhone" placeholder="甲方联系电话" class="phone-input editable-input">】，签字留样【<span style="padding-right: 80px;"/>】
                    </div>
            
                    <div class="section-content indent">
                      乙方人员：姓名【<span class="display-value">{{agreement.salesPersonName}}</span><input v-model="agreement.salesPersonName" placeholder="乙方联系人" class="editable-input">】，联系电话：【<span class="display-value">{{agreement.salesPersonPhone}}</span><input v-model="agreement.salesPersonPhone" placeholder="乙方联系电话" class="phone-input editable-input">】，签字留样【<span style="padding-right: 80px;"/>】
                    </div>
            
                    <div class="section-content indent">
                      备注：若甲方指定人员不在收货现场，甲方其他工作人员的签字也同等有效。
                    </div>
            
                    <div class="section-content">
                      <span class="section-number">10、</span>在本协议履行及相关业务合作过程中涉及货款、价格、质量等实质性内容或违约金、赔偿金等涉及乙方经济利益、义务负担的，需乙方确认的文件或/和协议，由乙方加盖公章后生效，否则对乙方不具有约束力。乙方任何部门或个人出具的任何处理意见或允诺，对乙方不具有约束力。
                    </div>
            
                    <div class="section-content">
                      <span class="section-number">11、</span>本协议自双方加盖公章或合同专用章之日起生效，一式贰份，各方各执一份。
                    </div>
                  </div>
          
                  <!-- 备用机型清单表格 -->
                  <div class="section-content">
                    备用机型清单：
                  </div>
                  <table class="contract-item">
                    <thead>
                      <tr>
                        <td width="50">序号</td>
                        <td width="120">产品名称</td>
                        <td width="100">型号</td>
                        <td width="60">单位</td>
                        <td width="60">数量</td>
                        <td width="100">含税单价</td>
                        <td width="100">含税金额（元）</td>
                        <td width="80">备注</td>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(item, index) in agreement.materialList" :key="index">
                        <td>{{index + 1}}</td>
                        <td><span class="display-value">{{item.sapProductName}}</span><input v-model="item.sapProductName" placeholder="产品名称" class="editable-input"></td>
                        <td><span class="display-value">{{item.manufacturerModel}}</span><input v-model="item.manufacturerModel" placeholder="型号" class="editable-input"></td>
                        <td><span class="display-value">{{item.unit}}</span><input v-model="item.unit" placeholder="单位" class="editable-input"></td>
                        <td>
                          <span class="display-value">{{item.quantity}}</span><input
                              v-model="item.quantity"
                              placeholder="数量"
                              type="number"
                              class="editable-input"
                              @input="calculateItemTotal(index)">
                        </td>
                        <td>
                          ¥<span class="display-value">{{item.unitPrice}}</span><input
                              v-model="item.unitPrice"
                              placeholder="单价"
                              type="number"
                              class="editable-input"
                              @input="calculateItemTotal(index)">
                        </td>
                        <td>¥{{getItemTotal(item)}}</td>
                        <td><span class="display-value">{{item.note}}</span><input v-model="item.note" placeholder="备注" class="editable-input"></td>
                      </tr>
                    </tbody>
                    <tfoot>
                      <tr>
                        <td>合计</td>
                        <td/>
                        <td/>
                        <td/>
                        <td/>
                        <td/>
                        <td>
                          ¥{{materialItemsTotalPrice}}
                        </td>
                        <td/>
                      </tr>
                    </tfoot>
                  </table>
          
                  <!-- 签字区域 -->
                  <div>（以下为签署页，无正文）</div>
                  <section class="signatures">
                    <div class="sign-item font-bold">
                      <div class="sign-label">
                        甲方：
                        <span class="display-value">{{agreement.customerName}}</span>
                        <input v-model="agreement.customerName" placeholder="请输入甲方名称" class="editable-input" style="width: 220px;">
                      </div>
                      <div class="sign-line">甲方代表：</div>
                      <div class="sign-date">签约时间：<span style="margin-left: 40px;">年</span><span style="margin-left: 40px;">月</span><span style="margin-left: 40px;">日</span></div>
                    </div>
                    <div class="sign-item font-bold">
                      <div class="sign-label">
                        乙方：
                        <span class="display-value">{{agreement.belongToCustomerNo}}</span>
                        <input v-model="agreement.belongToCustomerNo" placeholder="请输入乙方信息" class="editable-input" style="width: 220px;">
                      </div>
                      <div class="sign-line">乙方代表：</div>
                      <div class="sign-date">签约时间：<span style="margin-left: 40px;">年</span><span style="margin-left: 40px;">月</span><span style="margin-left: 40px;">日</span></div>
                    </div>
                  </section>
                </section>
              </div>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
  export default {
    name: "SparePartAgreementPrint",
    data() {
      return {
        agreement: {
          contractNo: "",
          clientContractNo: "",
          customerName: "",
          belongToCustomerNo: "",
          trialPeriod: "",
          startDate: "",
          endDate: "",
          expirationDate: "",
          customerContact: "",
          customerPhone: "",
          salesPersonName: "",
          salesPersonPhone: "",
          sendPeopleName: "",
          partyBContactPhone: "",
          materialList: [
            {
              materialCode: "",
              productName: "",
              specification: "",
              quantity: "",
              unitPrice: "",
              totalPrice: "",
              remark: "",
            },
          ],
        },
      };
    },
    computed: {
      // 合同明细总价
      materialItemsTotalPrice() {
        const materialList = (this.agreement && Array.isArray(this.agreement.materialList)) ? this.agreement.materialList : [];
        const total = materialList.reduce((sum, item) => sum + Number(item.unitPrice * item.quantity || 0), 0);
        const valid = Number.isFinite(total) ? total : 0;
        return valid.toLocaleString("zh-CN", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      },
    },
    mounted() {
      // 如通过 URL 传入 ids，可在此处读取并请求后端数据
      const id = this.$route && this.$route.query && this.$route.query.id;
      if (id) {
        this.fetchData(id);
      }
    },
    methods: {
      fetchData(id) {
        // 示例：根据后端接口调整
        this.$http.get("basic", `clientContracts/${id}`).then((res) => {
          if (res && res.success) {
            Object.assign(this.agreement, res.data || {});
          }
        }).catch(() => {});
      },
      getItemTotal(item) {
        const quantity = Number(item.quantity || 0);
        const unitPrice = Number(item.unitPrice || 0);
        const total = quantity * unitPrice;
        return total.toLocaleString("zh-CN", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      },
      calculateItemTotal() {
        // 触发重新计算总价
        this.$forceUpdate();
      },
      printHandle() {
        window.print();
      },
    },
  };
</script>

<style lang="scss" scoped>
.print-table {
  width: 210mm;
  margin: 0 auto;
  border-collapse: collapse;
  border: 1px solid #000;
  font-family: 'SimSun', '宋体', serif;
  font-size: 11pt;
  line-height:1.3;
  color: #000;
  background-color: #f0f0f0;
}
.print-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: transparent;
  /* 屏幕展示保持相对布局（非打印时） */
  line-height: 1.8cm;
  padding: 1.5cm 2cm 0;
}
.company-logo { width: 80px; }
.company-standad{
  color: #000;
  font-size: 10pt;
  font-weight: 600;
}
.printItem {
  padding: 0 1.5cm 1.5cm;
  table {
    width: 100%; 
    border: 1px solid #000;
    border-collapse: collapse; 
    margin-bottom: 20px;
    text-align: center;
    thead{
      font-weight: bold;
    }
    tr {
      td {
        border-bottom: 1px solid #000;
        border-right: 1px solid #000;
        padding: 5px;
      }
    }
  }
  
  .flex-justify{
    display: flex;
    justify-content: space-between;
  }
  .font-bold{
    font-weight: bold;
  }

  .title { font-size: 18pt; font-weight: bold; text-align: center; margin-bottom: 10px;}
  
  .agreement-body {
    margin: 15px 0;
  }
  
  .section-content {
    margin-bottom: 5px;
    text-indent: 24px;
  }
  
  .section-number {
    font-weight: bold;
  }
  
  .indent {
    text-indent: 48px;
  }
  .contract-item{
    margin-bottom: 0px;
  }
  .signatures { display: flex; justify-content: space-between; margin-top: 30px; }
  .sign-item { width: 45%; }
  .sign-label { margin-bottom: 10px; }
  .sign-line { margin-bottom: 10px; }
}
.display-value{
  display: none;
}
.editable-input{
  border: none;
  background: transparent;
  box-shadow: none;
  padding: 0;
  min-width: 120px;
  text-align: center;
  font-family: inherit;
  font-size: inherit;
  border-bottom: 2px solid #333;
  &:focus{
    outline: none;
  }
}

.contract-item {
  .editable-input{
    min-width: 50px;
    width: 50px;
  }
}

/* 打印专用规则 */
@media print {
   .printBtn,.editable-input {
    display: none;
  }
  .display-value{
    display: initial;
  }
  .print-table{
    font-size: 11pt;
  }
  .title{
    font-size: 18pt;
  }
  .company-standad{
    font-size: 10pt;
  }
  .print-header{
    padding: 0;
  }
  .print-area, .printItem {
    border: none;
    padding: 0 1px;
  }
  .print-table{
    border:none;
    background-color: #fff;
  }
  .signatures{
    page-break-inside: avoid;
  }
  
  /* 实现打印页码功能 */
  @page {
    margin: 0.5cm 1.5cm 1.5cm; /* 底部边距要足够大以容纳页脚 */
    counter-increment: page;
    @bottom-center{
      font-size: 8pt;
      color: #000;
      content: "第 " counter(page) " 页 共 " counter(pages) " 页";
    }
  }
}
</style>